/* Fills the Candy Rack slide cart's trust-icons block with the theme's version (snippets/cart-trust-icons.liquid).
   Candy Rack builds its cart on demand and rebuilds it on open and on cart changes, so watch the page and fill
   any empty .candy-rack-trust-icons div as soon as it appears. */
(() => {
  if (window.__cartTrustIcons) return;
  window.__cartTrustIcons = true;

  const template = document.getElementById('cart-trust-icons-template');
  if (!template) return;

  const fill = () => {
    document.querySelectorAll('.candy-rack-trust-icons').forEach((target) => {
      if (!target.querySelector('.bj-trust')) target.replaceChildren(template.content.cloneNode(true));
    });
  };

  // Mutation records arrive batched, so filling straight from the callback costs one cheap query per batch.
  // Our own insert triggers one more batch, which finds the div already filled and stops.
  fill();
  new MutationObserver(fill).observe(document.body, { childList: true, subtree: true });
})();
